import { render, staticRenderFns } from "./Retailers.vue?vue&type=template&id=a6a24c16&scoped=true&"
import script from "./Retailers.js?vue&type=script&lang=js&"
export * from "./Retailers.js?vue&type=script&lang=js&"
import style0 from "./Retailers.vue?vue&type=style&index=0&id=a6a24c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a24c16",
  null
  
)

export default component.exports